const capitalize = value => {
  if (!value) return null

  return value.toLowerCase().replace(/\b./, a => a.toUpperCase())
}

export default capitalize



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/capitalize.js